import Vue from 'vue';
// const VueMoment = () => import(/* webpackChunkName: "moment-vue" */ 'vue-moment') 
// const momentTZ = () => import (/* webpackChunkName: "moment-timezone" */ 'moment-timezone')
import VueMoment from 'vue-moment';
import momentTZ from 'moment-timezone';
Vue.use(VueMoment, {
    moment: momentTZ
});
const calSpec = {
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    lastDay: "[Yesterday]",
    nextWeek: "dddd",
    lastWeek: "[last] dddd",
    sameElse: "L"
};
export { momentTZ, calSpec };
